/* eslint-disable react/jsx-no-useless-fragment */
import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectIsMobileLayout } from '../../../selectors/layout';

interface IDeviceProps {
  mobile?: React.ReactNode;
  desktop?: React.ReactNode;
}

export const Device = ({ mobile = null, desktop = null }: IDeviceProps) => {
  const isMobile = useSelector(selectIsMobileLayout);

  if (isMobile) {
    return <>{mobile}</>;
  }

  return <>{desktop}</>;
};
